import React from 'react';
import { useAuth } from './AuthContext';
import { useNavigate } from 'react-router-dom';
import GlobalSearch from './GlobalSearch';
import NotificationBadge from './NotificationBadge';
import { useMobileMenu } from './MobileMenuContext';

interface NavbarProps {
    // Fonction pour ouvrir le panneau de notifications
    onOpenNotifPanel: () => void;
}

const Navbar: React.FC<NavbarProps> = ({ onOpenNotifPanel }) => {
    const { user, logout } = useAuth();
    const navigate = useNavigate();
    const { toggleMobileMenu } = useMobileMenu();

    // Logique de déconnexion
    const handleLogout = () => {
        logout();
        navigate('/login', { replace: true });
    };

    // Utilisation du nom complet depuis le backend
    const userName = user?.full_name || user?.first_name || 'Utilisateur';

    return (
        <>
            {/* Navbar principale */}
            <div className="navbar flex flex-row bg-base-100 rounded-box shadow-md mb-6 p-4">
                {/* Bouton hamburger (mobile uniquement) - Ouvre la sidebar */}
                <div className="flex-none lg:hidden">
                    <button
                        className="btn btn-ghost btn-circle"
                        onClick={toggleMobileMenu}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" className="inline-block w-6 h-6 stroke-current">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16"></path>
                        </svg>
                    </button>
                </div>

                {/* Conteneur de gauche (Titre) - Masqué sur mobile */}
                <div className="flex-1 hidden lg:block">
                    <h1 className="text-xl xl:text-2xl font-bold truncate">Bienvenue {userName},</h1>
                </div>

                {/* Titre mobile simplifié */}
                <div className="flex-1 lg:hidden">
                    <h1 className="text-lg font-bold truncate">FIDEX GRH</h1>
                </div>

                {/* Conteneur Central : Barre de recherche - Masquée sur mobile */}
                <div className="hidden lg:flex flex-grow justify-center mx-4 xl:mx-9 max-w-md">
                    <GlobalSearch placeholder="Rechercher employés, contrats, alertes..." />
                </div>

                {/* Conteneur de droite (Notifications & Profil) */}
                <div className="flex-none flex items-center gap-2 sm:gap-4">
                    {/* Bouton de notification */}
                    <NotificationBadge onClick={onOpenNotifPanel} />

                    {/* Menu profil */}
                    <div className="dropdown dropdown-end">
                        <label tabIndex={0} className="btn btn-ghost btn-circle avatar">
                            <div className="w-8 sm:w-10 rounded-full">
                                {/* SVG de profil */}
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-full h-full text-pwarning opacity-30">
                                    <path fillRule="evenodd" d="M7.5 6a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0ZM3.751 20.105a8.25 8.25 0 0 1 16.498 0 .75.75 0 0 1-.437.695A18.03 18.03 0 0 1 12 21.75c-2.73 0-5.41-.608-7.812-1.79a.75.75 0 0 1-.437-.695Z" clipRule="evenodd" />
                                </svg>
                            </div>
                        </label>
                        <ul tabIndex={0} className="mt-3 z-[1] p-2 shadow menu menu-sm dropdown-content bg-base-100 rounded-box w-52">
                            <li className="lg:hidden">
                                <span className="font-semibold">{userName}</span>
                            </li>
                            <li><a onClick={handleLogout} className='text-error'>Déconnexion</a></li>
                        </ul>
                    </div>
                </div>
            </div>

        </>
    );
};

export default Navbar;